<template>
  <b-modal
    id="modal-mapping"
    title="Mapping Preview"
    size="md"
    @show="preOpenModal"
    @shown="openModal"
    scrollable
    centered
  >
    <b-overlay :show="showOverlay" no-wrap />
    <el-alert
      v-if="!showErrorMessage"
      :title="`This is a preview of how elements will be mapped if you run this task right now.`"
      type="info"
      :description="`Elements in the source column will be copied to the corresponding element in the target column.  If you make changes to this dimension between now and when you run the task, then elements may be mapped differently or the task may fail.`"
      :closable="false"
    />
    <el-alert
      v-if="showErrorMessage"
      :title="`We couldn't find a mapping that worked...`"
      type="error"
      :description="errorMessage"
      show-icon
      :closable="false"
    >
    </el-alert>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column prop="source" label="Source"> </el-table-column>
      <el-table-column prop="target" label="Target"> </el-table-column>
    </el-table>
    <template v-slot:modal-footer>
      <el-button
        variant="primary"
        class="button float-right"
        @click="closeModal"
      >
        Close
      </el-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import TaskService from "../../services/TaskService";
import Helper from "../../utilities/Helper";
export default {
  props: {
    sourceDim: Object,
    targetDim: Object,
    mappingIndex: Number,
  },
  watch: {
    sourceDim(dim) {
      this.sourceDimSelection = dim;
    },
    targetDim(dim) {
      this.targetDimSelection = dim;
    },
  },
  computed: {
    ...mapState(["instanceId"]),
  },
  data() {
    return {
      tableData: [],
      showErrorMessage: false,
      showOverlay: true,
      sourceDimSelection: this.sourceDim,
      targetDimSelection: this.targetDim,
      errorMessage: "",

      // dimName: this.taskSourceCubeDims[this.dimIndex].name,
    };
  },
  methods: {
    handleError: Helper.handleError,
    trim: Helper.trim,
    showErrorWithMessage(message) {
      this.showErrorMessage = true;
      this.errorMessage = message;
    },
    preOpenModal() {
      this.showOverlay = true;
      this.tableData = [];
      this.showErrorMessage = false;
    },
    async openModal() {
      this.tableData = await this.formatTableData();
      this.showOverlay = false;
    },
    async closeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-mapping");
      });
    },
    async formatTableData() {
      // get selections off of dims
      let sourceSelection = this.sourceDimSelection.selection;
      let sourceSelectionType = this.sourceDimSelection.selectionType;
      let targetSelection = this.targetDimSelection.selection;
      let targetSelectionType = this.targetDimSelection.selectionType;

      // get element values

      let sourceDrillDown = (
        await TaskService.getSelectionDrillDown({
          instanceId: this.instanceId,
          dimName: this.sourceDimSelection.name,
          hierarchy: this.sourceDimSelection.hierarchy,
          selection: sourceSelection,
          selectionType: sourceSelectionType,
        })
      ).data.elements;

      let targetDrillDown = (
        await TaskService.getSelectionDrillDown({
          instanceId: this.instanceId,
          dimName: this.targetDimSelection.name,
          hierarchy: this.targetDimSelection.hierarchy,
          selection: targetSelection,
          selectionType: targetSelectionType,
          sourceDim: this.sourceDimSelection,
        })
      ).data.elements;

      // show error if lengths are different
      if (sourceDrillDown.length !== targetDrillDown.length) {
        if (sourceDrillDown.length > targetDrillDown.length) {
          this.showErrorWithMessage(
            `Your source selection has more N-level Elements (${sourceDrillDown.length}) than your target selection (${targetDrillDown.length}).  Please adjust your selections such that there are the same number of N-level elements in both, or this task will not be able to run successfully.`
          );
        } else {
          this.showErrorWithMessage(
            `Your target selection has more N-level Elements (${targetDrillDown.length}) than your source selection (${sourceDrillDown.length}).  Please adjust your selections such that there are the same number of N-level elements in both, or this task will not be able to run successfully.`
          );
        }
      }

      // create the table data for the mapping
      let mapping =
        sourceDrillDown.length < targetDrillDown.length
          ? targetDrillDown.map(({ name }, index) => ({
              source: sourceDrillDown[index]?.name,
              target: name,
            }))
          : sourceDrillDown.map(({ name }, index) => ({
              source: name,
              target: targetDrillDown[index]?.name,
            }));
      return mapping;
    },
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button {
  background-color: #7a7c80;
  color: white;
  border-color: white;
}
.cancel-button:focus {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
.cancel-button:hover {
  background-color: #606266;
  color: white;
  border-color: white;
  outline: none;
}
</style>